export default __webpack_public_path__ + "static/media/vision_at_center.72730065.svg";